import { Observable, type FetchFunction } from 'relay-runtime';
import { startDataFetchHold } from '@atlaskit/react-ufo/data-fetch-hold';

type RelayNetworkMiddleware = (
	next: FetchFunction,
	options?: {
		getIsEnabled?: () => boolean;
	},
) => FetchFunction;

export const ufoDataFetchHoldMiddleware: RelayNetworkMiddleware =
	(next, options) => (request, variables, cacheConfig, uploadables) => {
		if (options?.getIsEnabled?.() !== true) {
			return next(request, variables, cacheConfig, uploadables);
		}

		const source = next(request, variables, cacheConfig, uploadables);

		if ('subscribe' in source) {
			return Observable.create((sink) => {
				const releaseHold = startDataFetchHold({
					label: `relay-${request.operationKind}` as const, // `as const` to ignore `no-literal-string-in-object`
					name: request.name,
				});

				const subscription = source.subscribe(sink);

				return () => {
					try {
						subscription.unsubscribe();
					} finally {
						releaseHold?.();
					}
				};
			});
		}

		return source;
	};
